import { AdminContainer } from '@/components/containers/containers.component';
import { EditUserForm } from '@/components/forms/edit-user.form.component';
import { cn } from '@/lib/utils';
import { IfPermitted, UserPermissions } from '@/modules/Permissions';
import { useParams } from 'react-router-dom';

export default function EditUser() {
  const { userId } = useParams<{ userId: string }>();

  return (
    <IfPermitted permissions={[UserPermissions.EDIT_USER]}>
      <AdminContainer className={cn('flex flex-col')} title="Edit User">
        <EditUserForm userId={userId} />
      </AdminContainer>
    </IfPermitted>
  );
}
